export default {
  install(Vue) {
    Vue.prototype.get_working_hours = async function() {
      const api = `${window.endpoints.api}/BasicInformation/WorkShiftType`;
      const params = { IsEnable: true };

      const response = await this.$http.get(api, { params });
      const sorted = response.data.sort((a, b) => a.Seq - b.Seq);

      return sorted.map(({ Guid, Name }) => ({
        WorkShiftTypeGuid: Guid,
        WorkShiftType: Name
      }));
    };
  },
};